import { useEffect, useMemo } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { createLogger } from '../utils';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

type Key = {
  transcriptId: number;
};
export const useTranscriptsSocket = (websocketKey?: Key): Socket | undefined => {
  const getSocket = useGetSocket(SocketNamespace.Transcripts);

  const logger = useMemo(
    () =>
      createLogger({
        namespace: SocketNamespace.Transcripts,
      }),
    []
  );

  const transcriptId = websocketKey?.transcriptId;

  const socket = useMemo(() => {
    if (transcriptId == null) return undefined;
    return getSocket();
  }, [transcriptId, getSocket]);

  useEffect(() => {
    if (!socket || transcriptId == null) return;

    logger.log(`Subscribing to transcript: ${transcriptId}`);
    socket.emit('subscribe', transcriptId);

    return () => {
      logger.log(`Cleaning up socket for transcript: ${transcriptId}`);
      socket.emit('unsubscribe', transcriptId);
      socket.disconnect();
    };
  }, [socket, logger, transcriptId]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Transcripts);

  return socket;
};
